import { createSlice } from '@reduxjs/toolkit';

import { logOut } from 'common/auth/authService';

import { LegalEntityActions } from './actions';
import { InitialState } from './models';

const initialState: InitialState = {
  legalEntity: [],
};

const legalEntitySlice = createSlice({
  name: 'legalEntitySlice',
  initialState,
  reducers: {},
  extraReducers(builder) {
    // get legal entity
    builder.addCase(
      LegalEntityActions.getLegalEntity.fulfilled,
      (state, action) => {
        state.legalEntity = action.payload;
      }
    );
  },
});

export const LegalEntitySliceActions = legalEntitySlice.actions;
export default legalEntitySlice.reducer;
